import Icon from '../../components/Icon'

Icon.register({
  'brands/tiktok': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 209.9h-0.5c-45.5 0-87.8-14.6-122.3-39.3v178.7c0 89.7-72.9 162.5-162.6 162.5-89.7 0-162.6-72.8-162.6-162.6s72.8-162.6 162.6-162.6c7.6 0 15 0.5 22.3 1.5v89.9c-7.1-2.2-14.6-3.4-22.4-3.4-41.2 0-74.6 33.4-74.6 74.6 0 41.2 33.4 74.6 74.6 74.6 41.2 0 74.6-33.5 74.6-74.6v-349.4h88c0 0.3 0 0.7 0 1 0 7.3 0.6 14.2 1.9 21.2v0c6.3 33.6 26.2 62.4 53.9 80.2 19.2 12.7 42.2 20.1 66.9 20.1 0 0 0.1 0.1 0.1 0.1v87.4z'
      }
    ]
  }
})
